<mat-card>
    <div class="d-flex justify-content-between w-100" >
        <div class="container1">
            <div class="header">
                <h6>{{asset.trainingName ? (asset.trainingName  | translate) : ''}}</h6>
            </div>
            <div class="details w-100">
              <div class="detail">
                    <span class="key">{{'livlihoodCategories' | translate}}:</span>
                    <span class="value">
                        {{asset.livelihoodCategory ? getLabelByValue(asset.livelihoodCategory): 'NA'}}
                    </span>
                </div>
               <div class="detail">
                    <span class="key">{{'livelihoodActivity' | translate}}:</span>
                    <span class="value">
                                              {{asset.livelihoodActivity ? asset.livelihoodActivity : 'NA'}}

                    </span>
                </div>
                <!-- <div class="detail">
                    <span class="key">{{'category' | translate}}:</span>
                    <span class="value">
                        {{asset.category ? (asset.category | translate) : 'NA'}}
                    </span>
                </div> -->
                <div class="detail">
                    <span class="key">{{'trainingSource' | translate}}:</span>
                    <span class="value">{{asset.trainingSource ? (asset.trainingSource  | translate) : 'NA'}}</span>
                </div>
                <div class="detail">
                    <span class="key">{{'durationInDaysInDays' | translate}}:</span>
                    <span class="value">{{asset.durationInDays ? (asset.durationInDays | indianFormat) : 'NA'}}</span>
                </div>

                <div class="action-detail">
                  <button type="button" (click)="edit()">
                        @if (!readOnly) {
                            <img class="menu-icons" src="https://cdn.lokos.in/aajeevika/assets/img/edit.svg" alt="">
                            <span class="menu-labels">{{'edit' | translate}}</span>
                        } @else {
                            <img class="menu-icons" src="../../../../assets/images/eyeIcon.svg" alt="">
                            <span class="menu-labels">{{'view' | translate}}</span>
                        }
                    </button>
                    @if (!readOnly) {
                        <button type="button" (click)="delete()" [ngClass]="{'disabled': readOnly}">
                            <img class="menu-icons" src="https://cdn.lokos.in/aajeevika/assets/img/delete.svg" alt="">
                            <span class="menu-labels">{{'delete' | translate}}</span>
                        </button>
                    }
                </div>
            </div>
        </div>

    </div>
</mat-card>
